export * from './Component_HealthcareSpace.js';
//# sourceMappingURL=index.js.map